import React, { ReactNode } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import Modal from '../../../common/modals/Modal';
import SearchInput from '../../../common/inputs/SearchInput';
import StructureButton from './StructureButton';
import Button from '../../../common/Button';
import { EntityDTO } from '../../../../network/api/types/compte/EntityDTO';
import Loader from '../../../Loader';
import noresult from '../../../../img/createAccount/no-result.svg';
import entityApi from '../../../../network/api/entityApi';
import { getStructureNameV2 } from '../../../../services/utils';

type Props = {
  openModal:() => void;
  isModalOpen: boolean;
  saveStructure: (entity: EntityDTO) => void;
  selectedStructure?: EntityDTO[],
  selectedStructureIds?: string[],
};

type State = {
  results: EntityDTO[];
  entitySelected: EntityDTO;
  loading: boolean;
  noResult: boolean;
};

class FindStructureModal extends React.Component<Props, State> {
  state:State = {
    results: [],
    entitySelected: null,
    loading: false,
    noResult: false,
  };

  searchRef = React.createRef<HTMLInputElement>();

  buttonsRef = React.createRef<HTMLDivElement>();

  search = (value: string): void => {
    if (value === null || value === undefined || value === '') {
      this.setState({
        results: [], loading: false, noResult: false, entitySelected: null,
      });
    } else {
      this.setState({
        results: [], loading: true, noResult: false, entitySelected: null,
      });
      entityApi.fetchEntitiesBySearch(value).then((entities) => {
        const r = entities;
        if (r && r.dtos && r.dtos.length > 0) {
          this.setState({ results: r.dtos, loading: false });
        } else {
          this.setState({ results: [], loading: false, noResult: true });
        }
      });
    }
  };

  selectEntity = (entity: EntityDTO): void => {
    if (this.state.entitySelected && this.state.entitySelected.ou === entity.ou) {
      this.setState({ entitySelected: null });
    } else {
      this.setState({ entitySelected: entity });
      this.buttonsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  saveStructure = (entity: EntityDTO): void => {
    this.setState({ results: [], entitySelected: null });
    this.searchRef.current.value = '';
    this.props.saveStructure(entity);
  };

  onClose = (): void => {
    this.setState({ results: [], entitySelected: null, noResult: false });
    this.searchRef.current.value = '';
    this.props.openModal();
  };

  render(): ReactNode {
    return (
      <Modal
        isOpen={this.props.isModalOpen}
        onClose={() => this.onClose()}
      >
        <h3>
          <Translate value="CREATION.FIND_STRUCTURE" />
        </h3>
        <SearchInput
          inputRef={this.searchRef}
          placeholder={I18n.t('ADD_STRUCTURE.SEARCH_PLACEHOLDER')}
          onSearch={this.search}
        />
        {this.state.loading && <Loader />}
        {this.state.results && this.state.results.length > 0
        && (
        <div className="search-results">
          {this.state.results.map((entity) => (
            (entity.denominationSocialeAbregee
              || entity.denominationSociale
              || entity.intitule || entity.sigle)
            && (
            <StructureButton
              key={entity.ou}
              selected={this.state.entitySelected && this.state.entitySelected.ou === entity.ou}
              structureName={getStructureNameV2(entity)}
              structureGeographicAddress={entity.residence}
              structurePCcode={entity.departementResidence?.libelle}
              onClick={() => this.selectEntity(entity)}
              disabled={this.props.selectedStructure?.some((en) => en.ou === entity.ou)
                || this.props.selectedStructureIds?.some((id) => id === entity.ou)}
            />
            )
          ))}
        </div>
        )}
        {this.state.noResult
        && (
          <div>
            <img src={noresult} alt="Pas de résultat" />
            <Translate value="NO_RESULT" />
          </div>
        )}
        <div className={`modal-actions${this.state.entitySelected ? '' : ' hidden'}`}>
          <Translate value="CREATION.MAIL_TEXT" />
          <div className="button-container" ref={this.buttonsRef}>
            <Button
              type="third"
              i18nKey="actions.CANCEL"
              onClick={this.onClose}
            />
            <Button
              type="primary"
              onClick={() => this.saveStructure(this.state.entitySelected)}
              i18nKey="actions.CONFIRM"
            />
          </div>
        </div>
        <div />
      </Modal>
    );
  }
}

export default FindStructureModal;
